export default __webpack_public_path__ + "static/media/rampes_amea.f244bd7b.svg";